import React from "react";

export function RestlessSourceFormatter(cellContent, row, rowIndex) {
  return (
    <div>
      <strong>
        {row?.article && "Article"}
        {row?.comment && "Comment"}
        {row?.post && !row?.comment && "Post"}
      </strong>
    </div>
  );
}
